import { eventChannel, buffers } from 'redux-saga';
import { all, takeEvery, put, select, take, fork, delay } from 'redux-saga/effects';
import ddt from '@wix/da-ddt';
import { receiveHubMessage } from './actions';
import { fetchFeedbackCount } from '../../publicSession/actions';
import { addNotificationToQueue } from '../../Notifications/redux/actionCreators';
import { NotificationType } from '../../Notifications/redux/types';
import { HubChannel } from './types';
import { appMounted } from '../app/actions';
import { getHubState } from '../../publicSession/selectors';
import { dreamupGenerationSucceeded, dreamupGenerationFailed } from '../dreamup/actions';
export function* handleHubMessage({ payload }) {
    const { channel, data } = payload;
    switch(channel){
        case HubChannel.NOTIFICATIONS:
            const notificationData = data.data;
            yield put(addNotificationToQueue('live', NotificationType.Live, notificationData));
            ddt.log('hub', 'live notification enqueued', notificationData);
            break;
        case HubChannel.NEW_FEEDBACK:
            yield put(fetchFeedbackCount());
            ddt.log('hub', 'new feedback received');
            break;
        case HubChannel.DREAMSOFART:
            const dreamupData = data.data;
            if (dreamupData.status === 'complete') {
                yield put(dreamupGenerationSucceeded(dreamupData.generation_id, dreamupData.deviationids));
            } else {
                yield put(dreamupGenerationFailed(dreamupData.generation_id));
            }
            ddt.log('hub', 'dreamup art generation finished', dreamupData);
            break;
        default:
            break;
    }
}
function* handleAppMounted() {
    // wait for mount before doing anything
    yield take(appMounted);
    const hub = yield select(getHubState);
    if (!hub) {
        return;
    }
    // disable hub inside iframes
    if (typeof window !== 'undefined' && window.top !== window.self) {
        return;
    }
    // uncomment this to work on live notifications locally
    if (process.env.NODE_ENV !== 'production') {
        return;
    }
    // Lazy load hub but give the page some time to settle before we
    // startup the WS connection
    yield delay(3000);
    let hubUtils;
    try {
        hubUtils = yield import('../../utils/hub');
    } catch (e) {
    /* As this is pageload triggered this fails alot as people browse away / safe to ignore */ }
    if (!hubUtils) {
        return;
    }
    // event channels allow us to subscribe to an event source
    // that we can use with take() for listening to events
    const hubChannel = eventChannel((emitter)=>{
        hubUtils.setupHub(hub, (message)=>emitter(message));
        return ()=>{
            hubUtils.breakdownHub();
        };
    }, // going absolutely safe here, never drop a message
    buffers.expanding());
    // this is actually an unrolled takeEvery()
    while(true){
        const message = yield take(hubChannel);
        const { channel = '', data } = message;
        const channelName = channel.split('#')[0];
        yield put(receiveHubMessage(channelName, data));
    }
}
export default function* saga() {
    yield all([
        takeEvery(receiveHubMessage, handleHubMessage),
        fork(handleAppMounted)
    ]);
}
